import { render } from "./InstructionsPanel.vue?vue&type=template&id=200e7dd1&scoped=true"
import script from "./InstructionsPanel.vue?vue&type=script&lang=js"
export * from "./InstructionsPanel.vue?vue&type=script&lang=js"

import "./InstructionsPanel.vue?vue&type=style&index=0&id=200e7dd1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200e7dd1"]])

export default __exports__